import React from 'react'
// import './styles.css'

const CardStyles = {
  lightGreenBG: {
    backgroundColor: '#c4f2d8',
    color: '#397441',
  },
  darkGreenBG: {
    backgroundColor: '#397441',
    color: '#ffffff',
  },
  grayBG: {
    backgroundColor: '#eff4f0',
    color: '#397441',
  },
}

export default function ServiceCard({
  title,
  description,
  image,
  width = '75%',
  padding = 20,
  borderRadius = 10,
  BackgroundStyle = 'lightGreenBG',
  ImageHeight = 430,
  InvertedImage = false,
}) {
  return (
    <div
      style={{
        width: width,
        margin: '0 auto',
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        marginTop: 20,
        padding: padding,
        borderRadius: borderRadius,
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        ...CardStyles[BackgroundStyle],
      }}
    >
      <h3
        style={{
          marginBottom: 10,
          fontFamily: 'Poppins, sans-serif',
          fontSize: 22,
          fontWeight: 600,
          ...CardStyles[BackgroundStyle],
        }}
      >
        {title}
      </h3>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          ...CardStyles[BackgroundStyle],
          margin: 0,
          padding: 0,
        }}
      >
        {InvertedImage && image && (
          <img
            src={image}
            alt={title}
            style={{
              objectFit: 'scale-down',
              height: ImageHeight,
              borderRadius: 10,
              marginRight: 40,
            }}
          />
        )}
        <p
          style={{
            fontFamily: 'Poppins, sans-serif',
            fontSize: '16',
            fontWeight: 300,
          }}
          dangerouslySetInnerHTML={{ __html: description }}
        ></p>
        {!InvertedImage && image && (
          <img
            src={image}
            alt={title}
            style={{
              objectFit: 'scale-down',
              height: ImageHeight,
              borderRadius: 10,
              marginLeft: 40,
              marginTop: 30,
            }}
          />
        )}
      </div>
    </div>
  )
}
